/**
 * ファイルの拡張子・サイズを検証し、不正であればエラーメッセージを返す。
 *
 * zod（フォームバリデーション）とは別に hook 層で単独実装している理由:
 * - ドロップ/選択の **即時フィードバック**（zod は submit 時にしか走らない）
 * - **Base64 変換前のガード**（不正ファイルで fileToUrlByBase64 を実行させない）
 * - 不正ファイルを **フォーム値に混入させない**（onChange を呼ばずに弾く）
 */
export const validateFile = (
  file: File,
  accept: string[],
  maxSizeMb: number
): string | undefined => {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';
  if (!accept.includes(ext)) {
    return `${ext} は対応していません。`;
  }
  if (file.size > maxSizeMb * 1024 * 1024) {
    return `ファイルサイズは ${maxSizeMb}MB 以内にしてください。`;
  }
  return undefined;
};
